import React, {Component, PropTypes} from 'react'
import cx from 'classnames'
import DashboardPanel from './DashboardPanel'
import style from './RankingDashboardPanel.less'

class RankingDashboardPanel extends Component {
    static propTypes = {
        display: PropTypes.func,
        identify: PropTypes.func,
        onClick: PropTypes.func,
        value: PropTypes.array
    }

    static defaultProps = {
        display: (v) => v,
        identify: (v) => v,
        value: []
    }

    constructor(props) {
        super(props)

        this.state = {
            metrics: []
        }
    }

    componentWillMount() {
        const {identify, value} = this.props

        const metrics = value.sort((a, b) => identify(b) - identify(a)).slice(0, 10)
        this.setState({metrics})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value != this.props.value) {
            const {identify, value} = nextProps

            const metrics = value.sort((a, b) => identify(b) - identify(a)).slice(0, 10)
            this.setState({metrics})
        }
    }

    render() {
        const {light, display, identify, onClick, value, ...others} = this.props
        const {metrics} = this.state

        return (
            <div className={cx(style.default, {[style.light]: light})}>
                <DashboardPanel
                    light={light}
                    {...others}>
                    <ul className={style.metricGroup}>
                        {metrics.map((metric, index) => (
                            <li
                                key={index}>
                                <div className={style.rank}>{index + 1}</div>
                                <div className={style.container}>
                                    {onClick && (
                                        <a
                                            href=''
                                            onClick={(e) => onClick(e, metric)}>
                                            {display(metric)}
                                        </a>
                                    ) || display(metric)}
                                </div>
                            </li>
                        ))}
                    </ul>
                </DashboardPanel>
            </div>
        )
    }
}

export default RankingDashboardPanel


// WEBPACK FOOTER //
// ./lib/core/components/RankingDashboardPanel.js